export default __webpack_public_path__ + "static/media/Samarqand.aee6dfd2.jpeg";